module.exports = __webpack_public_path__ + "static/media/london_hornsoffa_djup_tyg_alis_320_miljo_2023_2.459f2e6c.jpg";